import ColocacionesList from './ColocacionesList'
import ColocacionEdit from './ColocacionEdit'

export default {
  list: ColocacionesList,
  edit: ColocacionEdit,
}
